<template>
  <div>
    <PageHeader>
      <el-tabs v-model="activeTabKey" @tab-click="handleClick">
        <el-tab-pane :label="$t('Fota.dataView')" name="first" v-if="dataRole"></el-tab-pane>
        <el-tab-pane :label="$t('Fota.deviceList')" name="second" v-if="deviceRole"></el-tab-pane>
        <el-tab-pane
          :label="$t('Fota.FirmwareManage')"
          name="third"
          v-if="firmwareRole"
        ></el-tab-pane>
      </el-tabs>
    </PageHeader>
    <Data v-if="activeTabKey === 'first'" :role="dataRoleChildList" />
    <Device v-if="activeTabKey === 'second'" :role="deviceRoleChildList" />
    <Firmware v-if="activeTabKey === 'third'" :firmwareRole="firmwareRoleChildList" />
  </div>
</template>

<script>
import getRoleFromPath from '@/mixins/getRoleFromPath'
import { getRoleByOperationCode } from '@/authorized'

import Data from './Data'
import Device from './Device'
import Firmware from './Firmware'
export default {
  mixins: [getRoleFromPath],
  components: {
    Data,
    Device,
    Firmware
  },
  data() {
    return {
      activeTabKey: ''
    }
  },
  created() {
    if (this.dataRole) {
      this.activeTabKey = 'first'
    } else if (this.deviceRole) {
      this.activeTabKey = 'second'
    } else if (this.firmwareRole) {
      this.activeTabKey = 'third'
    }
  },
  computed: {
    roleChildList() {
      const role = this.role.operationCode === 'dtu' && this.role.isPermission === 'Y'
      return role ? this.role.childList : []
    },
    // 数据概览
    dataRole() {
      let dataRole = getRoleByOperationCode(this.roleChildList, 'dtu_data')
      if (dataRole) {
        let val = getRoleByOperationCode(dataRole.childList, 'query')
        return val ? val.isPermission == 'Y' : false
      }
      return false
    },
    dataRoleChildList() {
      let dataRole = getRoleByOperationCode(this.roleChildList, 'dtu_data')
      return dataRole ? dataRole.childList : []
    },
    // 设备列表
    deviceRole() {
      let deviceRole = getRoleByOperationCode(this.roleChildList, 'dtu_device')
      if (deviceRole) {
        let val = getRoleByOperationCode(deviceRole.childList, 'query')
        return val ? val.isPermission == 'Y' : false
      }
      return false
    },
    deviceRoleChildList() {
      let deviceRole = getRoleByOperationCode(this.roleChildList, 'dtu_device')
      return deviceRole ? deviceRole.childList : []
    },
    // 固件管理
    firmwareRole() {
      let firmwareRole = getRoleByOperationCode(this.roleChildList, 'dtu_firmware')
      if (firmwareRole) {
        let val = getRoleByOperationCode(firmwareRole.childList, 'query')
        return val ? val.isPermission == 'Y' : false
      }
      return false
    },
    firmwareRoleChildList() {
      let firmwareRole = getRoleByOperationCode(this.roleChildList, 'dtu_firmware')
      return firmwareRole ? firmwareRole.childList : []
    }
  },
  methods: {
    handleClick() {}
  }
}
</script>

<style lang="scss" scoped>
.el-tabs {
  margin-left: 64px;
  float: left;
}
</style>
